import React, { useMemo } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import AllSvg from './AllSvg';
import { useEffect } from 'react';
import { useState } from 'react';

const VideoSlick = ({
	dots,
	infinite,
	speed,
	autoplay,
	autoplaySpeed,
	slidesToShow,
	slidesToScroll,
	centerMode,
	nextArrow,
	prevArrow,
	tabletSlidesToShow,
	tabletSlidesToScroll,
	mobileSlidesToShow,
	mobileSlidesToScroll,
	lang,
	galleryData,
}) => {
	const setting = {
		dots: dots, // 슬라이드 밑에 점 보이게
		infinite: infinite, // 무한으로 반복
		speed: speed, // 넘기는 속도
		autoplay: autoplay, // 자동으로 넘김
		autoplaySpeed: autoplaySpeed, //자동으로 넘어가는 속도
		slidesToShow: slidesToShow, // 스크린에 보여지는 슬라이드 개수
		slidesToScroll: slidesToScroll, // n장씩 뒤로 넘어가게 함
		// centerMode: true,   // 중앙정렬
		// centerPadding: '0px', // 0px 하면 슬라이드 끝쪽 이미지가 안잘림
		nextArrow: <></>, // 이전 화살표
		prevArrow: <></>, // 다음 화살표
		responsive: [
			// 반응형 웹 구현 옵션
			{
				breakpoint: 1024, //화면 사이즈 960px
				settings: {
					//위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
					slidesToShow: tabletSlidesToShow,
					slidesToScroll: tabletSlidesToScroll,
				},
			},
			{
				breakpoint: 767, //화면 사이즈 768px
				settings: {
					//위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
					slidesToShow: mobileSlidesToShow,
					slidesToScroll: mobileSlidesToScroll,
				},
			},
		],
	};
	const dividedData = useMemo(() => {
		if (!galleryData || !Array.isArray(galleryData)) {
			return [];
		}
		return Array.from({ length: Math.ceil(galleryData.length / 2) }, (_, i) =>
			galleryData.slice(i * 2, i * 2 + 2),
		);
	}, [galleryData]);

	const [uuid, setUuid] = useState();

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://d328y0m0mtvzqc.cloudfront.net/prod/powaBoot.js';
		script.async = true;
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		};
	}, []);

	useEffect(() => {
		// Handles if the powa script finishes loading before the component is ready.
		if (typeof window !== 'undefined' && window.powaBoot) {
			window.powaBoot();
		}
	}, [uuid]);

	return (
		<Slider {...setting}>
			{dividedData.map((ele, index) => {
				return (
					<div className="video-item-container" key={index}>
						{ele.map((el, idx) => {
							return (
								<div className="item" key={idx}>
									<div
										className="video_area"
										onClick={() => {
											setUuid(el?.videoUuid);
										}}
									>
										<div
											className="powa"
											id={`powa-${el?.videoUuid}`}
											data-uuid={el?.videoUuid}
											data-org="chosun"
											data-api="prod"
											data-env="prod"
										></div>
									</div>
									{/* <div aria-label='Play' title='Play' className='powa-shot-image' style={{ backgroundImage: `url(${el.imgUrl})` }}>
                <div className='powa-button-block'>
                  <button className='powa-button'>
                    <AllSvg type={'play-button'} />
                  </button>
                </div>
              </div> */}
									<div className="tt">{el?.videoNm}</div>
								</div>
							);
						})}
					</div>
				);
			})}
		</Slider>
	);
};

export default VideoSlick;
